Namespace 'Monitoring.Views.Dashboards.Modes.Publications'

class Monitoring.Views.Dashboards.Modes.Publications.PostsSectionView extends Backbone.View

  template: JST["backbone/templates/monitoring/dashboards/modes/publications/posts_section"]

  initialize: (options) ->
    @searchQuery = options.searchQuery

    @provider = options.provider
    @vuePostsSelectorComponent = new VueInBackbone.VueApp('publications-session',
      {
        searchQuery: @searchQuery.toJSON(),
        filters: null,
        provider: @provider
      }
    )
    @vuePostsSelectorComponent.on('initialSearchStarted',     @initialSearchStarted)
    @vuePostsSelectorComponent.on('initialSearchCompleted',   @initialSearchCompleted)
    @vuePostsSelectorComponent.on('selectionHasChange',       @selectionHasChange)
    @vuePostsSelectorComponent.on('searchComments',           @searchComments)
    @vuePostsSelectorComponent.on('reviewSession',            @createReviewSession)
    @vuePostsSelectorComponent.on('campaignReport',           @showCampaignReport)
    @vuePostsSelectorComponent.on('publicationsReport',       @showPublicationsReport)
    @vuePostsSelectorComponent.on('hideFilters',              @hideFilters)

  render: ->
    @$el.html(@template)
    @$el.find('.posts-section').append(@vuePostsSelectorComponent.el)
    @vuePostsSelectorComponent.render()

  reload: ->
    @vuePostsSelectorComponent.update({ searchQuery: @searchQuery.toJSON() })

  reloadFilters: (filters) ->
    @vuePostsSelectorComponent.update({ filters: filters })

  initialSearchStarted: =>
    @trigger('searchStarted')

  initialSearchCompleted: (session) =>
    @trigger('searchCompleted', session)
    @updateQuery()

  hideFilters: =>
    @trigger('hideFilters')

  selectionHasChange: =>
    @trigger('selectionHasChange')

  searchComments: (selectedPosts) =>
    dateFrom = new Date(@searchQuery.get('post_from'))
    @trigger('searchComments', selectedPosts, dateFrom)

  createReviewSession: (selectedPosts) =>
    query = @searchQuery.deepCopy()
    @addSelectedPostsTo(query, selectedPosts)
    query.set('reviewMode', true)
    query.set('analysisMode', false)
    query.set('status', ['UNKNOWN'])
    query.set('review_status', ['NOT_REVIEWED'])
    query.set('review_from_analysis', true)
    query.set('per_post_active', true)
    query.set('all_posts_active', false)

    oldestPost = @oldestPost(selectedPosts)
    query.addDateFrom(oldestPost.timestamp)
    @eventAggregator.trigger('clickOnCloneDashboard', query)

  addSelectedPostsTo: (query, selectedPosts) =>
    selectedPosts.forEach (post) =>
      query.addPost(post.parent_search_id, post.provider)

  oldestPost: (selectedPosts) =>
    sortedSelectedPostsByDate = selectedPosts.sort((post, anotherPost) => new Date(post.timestamp) - new Date(anotherPost.timestamp))
    sortedSelectedPostsByDate[0]

  showCampaignReport: (selectedPosts) =>
    $.post('/monitoring/reports/campaign/validate_hierarchy_for_report', {}, (response) =>
      if response.valid
        @showReport('campaign', selectedPosts)
      else
        swal("Hierarchy invalid for this report", "It is empty or invalid", "error")
    )

  showPublicationsReport: (selectedPosts) =>
    @showReport('publications', selectedPosts)

  showReport: (name, selectedPosts) =>
    account_id = Keepcon.currentAccount.id
    url = "/monitoring/reports/#{name}?account_id=#{account_id}"
    openReport(url, "_blank", selectedPosts)

  openReport = (url, target, posts) ->
    form = document.createElement('form')
    form.action = url
    form.method = "POST"
    form.target = target or '_self'
    token = document.createElement('input')
    token.setAttribute("type", "hidden");
    token.name = "authenticity_token"
    token.value = authToken()
    form.appendChild token
    for post in posts
      input = document.createElement('input')
      input.setAttribute("type", "hidden");
      input.name = "posts[]"
      input.value = post.content_id.replace(/^.*---/, '')
      form.appendChild input
    form.style.display = 'none'
    document.body.appendChild form
    form.submit()
    return

  updateQuery: =>
    $.ajax
      url: '/monitoring/dashboard/update_query',
      type: 'POST',
      data: @searchQuery.toJSON()
      async: false
      success: (response) =>
        console.log('query updated')

  destroy: ->
    @remove()

  remove: ->
    @vuePostsSelectorComponent.remove()
    super()
